export enum DesktopSectionTypes {
  WORKSPACE,
  LEARNING,
  SEARCH,
  SUBSCRIPTION,
}
